import { Link } from "react-router-dom";
import { ArrowRight, Mail, Phone } from "lucide-react";
import { CONTACT } from "../data/apps";
import { Reveal } from "./Shared";

export const ContactCTA = () => (
  <section data-testid="contact-cta" className="py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-navy px-8 py-14 sm:px-14 sm:py-20 text-white">
          <div className="absolute -top-24 -right-24 h-80 w-80 rounded-full bg-maison/20 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 h-80 w-80 rounded-full bg-ctqibla/20 blur-3xl" />
          <div className="relative max-w-2xl">
            <h2 className="font-display font-semibold tracking-tight text-3xl sm:text-4xl lg:text-5xl">
              Envie de rejoindre l'écosystème TIRERA GROUP ?
            </h2>
            <p className="mt-5 text-white/70 leading-relaxed">
              Partenariats, presse, opportunités ou simple question — notre équipe à Bamako
              vous répond.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <Link
                to="/contact"
                data-testid="cta-contact-button"
                className="group inline-flex items-center gap-2 rounded-full bg-white px-7 py-3.5 text-sm font-semibold text-navy hover:bg-white/90 transition-colors"
              >
                Nous contacter
                <ArrowRight size={17} className="transition-transform group-hover:translate-x-1" />
              </Link>
              <a href={`mailto:${CONTACT.email}`} className="inline-flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white transition-colors">
                <Mail size={16} /> {CONTACT.email}
              </a>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="inline-flex items-center gap-2 text-sm font-medium text-white/80 hover:text-white transition-colors">
                <Phone size={16} /> {CONTACT.phone}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
